import React, { useState } from 'react';
import { StarIcon, ShieldIcon, AwardIcon } from 'lucide-react';
import { useModal } from '../App';
export function Hero() {
  const [videoReady, setVideoReady] = useState(false);
  const {
    openModal
  } = useModal();
  return <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-188">
      <img src="https://cdn.magicpatterns.com/uploads/ej85nYXphYuzNRdwMg9rTT/AdobeStock_542074179-1920w.jpg" alt="Rooftop aerial view" className="absolute inset-0 w-full h-full object-cover" style={{
      opacity: videoReady ? 0 : 1,
      transition: 'opacity 0.8s ease'
    }} data-id="element-189" />
      <video autoPlay muted loop playsInline onCanPlay={() => setVideoReady(true)} className="absolute inset-0 w-full h-full object-cover" style={{
      opacity: videoReady ? 1 : 0,
      transition: 'opacity 0.8s ease'
    }} src="https://cdn.magicpatterns.com/uploads/vjH76tzHAmscvVUhpbFYHW/a-new-roof-is-installed-on-a-private-house-aerial-view-SBV-349176172-preview.mp4" data-id="element-190" />
      <div className="absolute inset-0 z-10" style={{
      background: 'rgba(15,23,42,0.65)'
    }} data-id="element-191" />

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32 flex flex-col items-center text-center" data-id="element-192">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 backdrop-blur-sm mb-8" data-id="element-193">
          <ShieldIcon className="h-4 w-4 text-amber-500" data-id="element-194" />
          <span className="text-sm font-medium text-slate-300" data-id="element-195">
            Proudly Serving Austin &amp; Surrounding Areas Since 2008
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 max-w-5xl" data-id="element-196">
          Protect Your Home With a{' '}
          <span className="text-amber-500" data-id="element-197">Roof Built to Last</span>
        </h1>

        <p className="text-xl md:text-2xl text-slate-300 mb-10 max-w-3xl font-light" data-id="element-198">
          No Haggling. No Hidden Fees. No Pressure — Ever.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-16" data-id="element-199">
          <button onClick={openModal} className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(245,158,11,0.3)]" data-id="element-200">
            Get My Free Quote
          </button>
          <button onClick={openModal} className="bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg transition-colors" data-id="element-201">
            Call (555) 000-0000
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-3xl" data-id="element-202">
          <div className="flex items-center justify-center gap-3 bg-slate-800/40 backdrop-blur-md border border-slate-700/50 rounded-xl p-4" data-id="element-203">
            <div className="flex text-amber-500" data-id="element-204"><StarIcon className="h-5 w-5 fill-current" data-id="element-205" /></div>
            <span className="text-white font-medium" data-id="element-206">4.9 Google Rating</span>
          </div>
          <div className="flex items-center justify-center gap-3 bg-slate-800/40 backdrop-blur-md border border-slate-700/50 rounded-xl p-4" data-id="element-207">
            <AwardIcon className="h-5 w-5 text-amber-500" data-id="element-208" />
            <span className="text-white font-medium" data-id="element-209">500+ Roofs Installed</span>
          </div>
          <div className="flex items-center justify-center gap-3 bg-slate-800/40 backdrop-blur-md border border-slate-700/50 rounded-xl p-4" data-id="element-210">
            <ShieldIcon className="h-5 w-5 text-amber-500" data-id="element-211" />
            <span className="text-white font-medium" data-id="element-212">Licensed &amp; Insured</span>
          </div>
        </div>
      </div>
    </section>;
}